import { Formik, Form as FormikForm, useFormikContext } from 'formik'
import React from 'react'
import { SubscriptionContext } from '../../context'
import { propsToValues, setupValidationSchema } from './validations'
import { InputFieldWithLabel } from '@components/Form/Fields'
import { Grid } from '@components/layout/Grid'
import { Stack } from '@UILibrary/Stack'
import { Button } from '@components/Button'
import PhoneInput from '@shared/PhoneInput'

const baseClass = 'billable-details'

type DetailsProps = {
  formRef?: React.RefObject<HTMLFormElement>
}

const Details = (props: DetailsProps  ) => {
  const { state: { billable, address }, actions: { submitBillingDetails } } = React.useContext(SubscriptionContext)

  const handleSubmit = (values) => {
    return submitBillingDetails(values)
  }

  return (
    <Formik
      validateOnChange
      onSubmit={handleSubmit}
      validationSchema={setupValidationSchema()}
      initialValues={
        propsToValues(billable, address)
      }>
        {() => (
          <Grid className='app-form'>
            <FormFields {...props} />
          </Grid>
        )}
      </Formik>
  )
}

const FormFields = ({ formRef }: DetailsProps) => {
  return (
    <FormikForm ref={formRef}>
      <div className={`${baseClass}__fields-container`}>
        <div className={`${baseClass}__fields-group`}>
          <h4>Contact details</h4>
          <small>Details of the contactable person to be shown on the invoice.</small>
          <InputFieldWithLabel name="contactName" label="Name *" />
          <InputFieldWithLabel name="contactEmail" label="Email *" />
          <InputFieldWithLabel name="contactPhone" label="Phone *" />
          <h4>Company details</h4>
          <small>Information regarding company tax etc.</small>
          <InputFieldWithLabel name="companyVat" label="Company VAT number" />
        </div>
        <div className={`${baseClass}__fields-group`}>
          <h4>Billing Address</h4>
          <small>The address as it will appear on the invoice.</small>
          <InputFieldWithLabel name="line1" label="Address *" />
          <InputFieldWithLabel name="line2" label="Address 2" />
          <InputFieldWithLabel name="line3" label="Address 3" />
          <InputFieldWithLabel name="suburb" label="Suburb" />
          <InputFieldWithLabel name="city" label="City *" />
          <InputFieldWithLabel name="country" label="Country *" />
          <InputFieldWithLabel name="code" label="Code *" />
        </div>
      </div>
    </FormikForm>
  )
}

const DetailsActions = ({ formRef }: DetailsProps) => {
  const { actions: { navigateToIndex }} = React.useContext(SubscriptionContext)

  const handleSave = () => {
    if (formRef && formRef.current) {
      formRef.current.dispatchEvent(new Event('submit'))
    }
  }

  return (
    <Stack horizontal spacing="s">
      <Button secondary onClick={() => navigateToIndex()}>Cancel</Button>
      <Button primary onClick={() => handleSave()}>Save</Button>
    </Stack>
  )
}

export { Details, DetailsActions }
